import { useCallback } from 'react'

import { useCatalogItemCartContext } from '../../../../providers/CatalogItemCartProvider'
import { useConversation } from '../../../../providers/ConversationProvider'
import { type ConversationTelemetryEvent } from '../../../../value-objects/ConversationTelemetryEvent'
import {
  type ConversationCatalogItemComponent,
  type ConversationChoiceOption,
  type ConversationTurnItem,
} from '../../../../value-objects/ConversationTurnItem'
import { ConversationStreamStatuses } from '../../models/useConversationStream'

interface IUseRunConversationTurnPresenterResult {
  data: {
    items: ConversationTurnItem[]
    telemetry: ConversationTelemetryEvent[]
  }
  states: {
    isStreaming: boolean
    thinkingLabel: Nullable<string>
  }
  commands: {
    selectChoice: (option: ConversationChoiceOption) => void
    sendMessage: (message: string) => boolean
    selectCatalogItem: (item: ConversationCatalogItemComponent) => void
  }
}

export const useRunConversationTurnPresenter =
  (): IUseRunConversationTurnPresenterResult => {
    const { items, status, thinkingLabel, telemetry, sendMessage } =
      useConversation()
    const { selectCatalogItem } = useCatalogItemCartContext()

    const selectChoice = useCallback(
      (option: ConversationChoiceOption) => sendMessage(option.message),
      [sendMessage]
    )

    return {
      data: { items, telemetry },
      states: {
        isStreaming: status === ConversationStreamStatuses.STREAMING,
        thinkingLabel,
      },
      commands: { selectChoice, sendMessage, selectCatalogItem },
    }
  }
